// Types of shapes supported by Leaflet drawing capabilities.
const ShapeType = {
  NONE:       'none',
  CIRCLE:     'circle',
  POLYGON:    'polygon',
  SQUARE:     'square'
};

export default ShapeType;
